<template>
  <div class="col-lg-3 col-md-4 col-12 mb-4">
      <div class="inspiration_block">
            <div class="slide text-center" @click="showModal">
                <div class="img_box" @click="selectVideo">
                    <img class="mx-auto" width="280" height="280" :src="data.img" :alt="'customer purchased '">
                </div>
            </div>
            <div class="info_box">
                <h3 class="mb-0">{{data.title}}</h3>
                <p class="my-2">{{data.description}}</p>
            </div>

   
      </div>

        <ClientOnly>
            <div v-if="flagShowModal" :key="`${modalKey}_inspiration_preview`">
                <Teleport to="#teleports">
                    <div class="modal fade" id="modal2" data-bs-backdrop="true" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="myModalRef">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-body">
                                    <div class="header_box" @click="hideModal">
                                        <SvgHeaderSvg :type="'close'" class="largesvg"/>
                                    </div>
                                    <div class="text-center">
                                        <div>
                                            <div class="loader text-center" v-if="showLoader">
                                                <img loading="lazy" alt="loader" src="~/assets/assets/loader.svg" />
                                            </div>
                                            <div v-if="data.video" >
                                                <div :key="`${modalKey}_inspiration_preview_child`" v-show="!showLoader">
                                                    <video
                                                     :key="`${modalKey}_inspiration_preview_child_video`"
                                                        ref="videoPlayer"
                                                        autoplay
                                                        muted
                                                        @contextmenu.prevent=""
                                                        playsinline
                                                        class="video_play radious_four"
                                                        @loadeddata="onVideoLoaded"
                                                        @playing="onVideoPlaying"
                                                        >
                                                     <source :key="`${modalKey}_inspiration_preview_child_video_src`" :src="data.video" type="video/mp4" />
                                                    </video>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <img :src="data.img" alt="Inspiration Image" class="img-fluid radious_four" />
                                            </div>
                                        </div>

                                        <div class="detail_box">
                                            <p v-if="data.title" class="mb-0">{{data.title}}</p>
                                            <span v-if="data.description" class="mb-0">{{data.description}}</span>
                                        </div>  
                                        <div class="view_all_btn mt-4">
                                            <router-link v-if="data.link != null" :to="localePath(data.link)" class="btn-animation">
                                            <span>View</span>
                                            </router-link>
                                        </div>              
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Teleport>
            </div>
        </ClientOnly>
  </div>
</template>

<script setup>
  const showLoader = ref(false)
  const localePath = useLocalePath()
  const { data } = defineProps(['data'])

  const flagShowModal = ref(false);
  const myModalRef = ref(null);

  const modalKey = ref(0);

  function playVideo(event) {
      const video = event.target;
      video.play();
  }

  function pauseVideo(event) {
      const video = event.target;
      video.pause();
      video.currentTime = 0; // Optional: reset video to start
  }


  const showModal = () => {
  flagShowModal.value = true;
  modalKey.value++
  nextTick(() => {
    const modalElement = myModalRef.value;
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
      // Make sure loader is shown while video is loading
      if (data.video) {
        showLoader.value = true;
      }
    }
  });
};

    const hideModal = () => {
      flagShowModal.value = false;
      const modalElement = myModalRef.value;
      modalKey.value++
      if (modalElement) {
          const modalInstance = bootstrap.Modal.getInstance(modalElement);
          if (modalInstance) {
              modalInstance.hide();
          }
        }
    };
    const videoPlayer = ref(null);
    const selectedVideo = ref(data)

    const selectVideo = (data) => {
        selectedVideo.value = {
          url: data.video,
          description: data.description,
          title: data.title,
          image: data.img,
      };
      showLoader.value = !!data.video;  
    };


    const onVideoLoaded = () => {
        showLoader.value = false;
    };

    const onVideoPlaying = () => {
        showLoader.value = false;
    };
</script>

<style scoped>
.inspiration_block {
    padding: 16px;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
}
     
  h3 {
      font-size: 16px;
      font-weight: 600;
      color: #353535;
  }
 
  p {
      font-size: 16px;
      color: #353535;
      font-weight: 500;
  }

  .info_box {
      text-align: center;
      margin-top: 8%;
  }
  .video_box {
      position: relative;
      width: 100%;
      height: 280px;
      overflow: hidden;
  }

  video{
      width: 100%;
      height: 100%;
      display: block;
  }
  .header_box {
    cursor: pointer;
    float: right;
}
.largesvg {
    transform: scale(1.3);
    }
    .view_all_btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .view_all_btn a {
    color: #212529;
    background: #fff;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    font-size: 14px!important;
    letter-spacing: 1.4px;
    font-weight: 600;
    padding: 9px 25px;
    text-transform: uppercase;
    min-width: 160px;  
    text-align: center;
    transition: all 0.5s;
    cursor: pointer;
    position: relative;
  } 

  .btn-animation span{
    position: relative;
    left: 0px;
    transition: all 0.3s ease-out;
  }

  .btn-animation:hover span {
      left: -12px;
  }

  .btn-animation::after{
    content: '';
    width: 6px;
    height: 11px;
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translate(-15px, -50%);
    background-image: url('@/assets/svg/arrow-black.svg');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0;
    transition: all 0.3s ease-out;
  }

  .btn-animation:hover::after {
      opacity: 1;
  }

/* 
  .img_box{
      max-height: 279px;
      max-width: 278px;
      overflow: hidden;
  }
  img{
      transform: scale(1.2);
  } */

  @media(max-width: 767px){
      img{
          transform: scale(1);
      }
      .img_box {
          max-height: 100%;
          max-width: 100%;
          overflow: hidden;
      }
  }
</style>
